import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import i18n from '../../../../i18n';
import AuctionStatusForm from './AuctionStatusForm';

export default function EditAuctionStatus({
  show,
  isLoading,
  selectedRow,
  formData,
  onClose,
  onToggle,
  onRemarkChange,
  onSave,
  btnLoading,
}) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t('auction_report')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : selectedRow ? (
          <AuctionStatusForm formData={formData} onToggle={onToggle} onRemarkChange={onRemarkChange} />
        ) : (
          <p>{i18n.t('no_data_available')}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {i18n.t('close')}
        </Button>
        <Button variant="primary" onClick={onSave} disabled={btnLoading}>
          {btnLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
              {i18n.t('saving')}
            </>
          ) : (
            i18n.t('save_changes')
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
